import {getCookie} from "./helpers";

(function () {
    const params = window.location.search;
    const utmSource = new URLSearchParams(params).get('utm_source');
    const utmLinks = document.querySelectorAll('[data-utm-link]');

    if (utmSource) {
        document.cookie = 'link=' + params + '; path=/; domain=' + location.hostname + '; max-age=3600; Secure; SameSite=Strict';
    }

    utmLinks.forEach(link => {
        const defaultLink = link.getAttribute('href');

        if (defaultLink) {
            const newLink = (getCookie('link') && getCookie('link') !== undefined) ?
                defaultLink + getCookie('link') :
                defaultLink + '?utm_source=landing&utm_medium=cashx.online';

            link.setAttribute("href", newLink);
        }
    })
})();

(function () {
    const params = window.location.search;
    const utmSource = new URLSearchParams(params).get('utm_source');
    const dwnButtons = document.querySelectorAll('[data-dwn-btn]'); //.dwnbtn
    const utmButtons = document.querySelectorAll('[data-utm-btn]'); //.utmbtn
    let refParam = '';

    if (utmSource) {
        refParam = '&referrer=' + encodeURIComponent(params.replace('?', ''));
    } else {
        const refUrl = document.referrer;

        if (refUrl) {
            const referrer = new URL(refUrl).hostname.replace('www.', '');

            if (referrer === 'google.com') {
                refParam = '&referrer=utm_source%3Dlanding%26utm_medium%3Dorganic%26utm_campaign%3Dgoogle-organic';
            } else {
                refParam = '&referrer=utm_source%3Dlanding%26utm_medium%3Dlanding%26utm_campaign%3D' + referrer;
            }
        } else {
            refParam = '&referrer=utm_source%3Ddirect%26utm_medium%3Dlanding%26utm_campaign%3Ddirect';
        }
    }

    dwnButtons.forEach(el => {
        el.href = el.href + refParam;
    });

    if (params) {
        refParam = params;
    } else {
        refParam = '?utm_source=cashxonline&utm_medium=site_new';
    }

    utmButtons.forEach(el => {
        el.href = el.href + refParam;
    });
})();

(function () {
    const browserOpenLinks = document.querySelectorAll('[data-webview]');

    if (browserOpenLinks) {
        browserOpenLinks.forEach(link => {
            link.addEventListener('click', e => {
                e.preventDefault();

                const userAgent = navigator.userAgent || navigator.vendor;
                const targetUrl = getCookie('target_url') || '?utm_source=cashxonline&utm_medium=site_new';
                const paramsUrl = targetUrl.split("?");
                const fullUrl = link.href + '?' + paramsUrl[1]
                const shortUrl = link.href.slice(8) + '?' + paramsUrl[1]

                if (/iPad|iPhone/.test(userAgent)) {
                    window.location.href = `googlechrome://${shortUrl}`;

                    setTimeout(() => window.location.href = fullUrl, 3000)
                    return;
                }

                window.location.href = `intent:${fullUrl}#Intent;end`;

                setTimeout(() => window.location.href = fullUrl, 3000)
                return;
            });
        });
    }
}());
